import { Component } from '@angular/core';

@Component({
  selector: 'app-return-policy',
  templateUrl: './return-policy.component.html'
})
export class ReturnPolicyComponent {}
